<template>
  <div id="app">
    <v-app id="inspire" dark>
      <v-toolbar color>
        <router-link to="/"><img src="assets/i/logo-robonomics-2.svg" height="38px" width="38px"></router-link>
        <v-toolbar-title>Robonomics status</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn flat to="/">Status</v-btn>
          <v-btn flat to="/net">Net</v-btn>
          <!-- <v-btn flat to="/msg">Msg</v-btn> -->
          <v-chip small color="primary">
            <a
              style="color:white;text-decoration: none;"
              href="https://github.com/airalab/robonomics_contracts/releases/tag/v1.0-rc2"
              target="_blank"
            >ENS v{{version}}</a>
          </v-chip>
        </v-toolbar-items>
      </v-toolbar>
      <v-content>
        <v-container fluid grid-list-md :class="{ 'page': $route.path !== '/graph' }">
          <v-layout row wrap>
            <v-flex md12>
              <router-view/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import config from "./config";

export default {
  name: "App",
  data() {
    return {
      version: config.VERSION
    };
  },
  created() {
    this.$store.dispatch("statistics/init");
    this.$store.dispatch("net/init");
  }
};
</script>
